export const MAX_REACTIONS_TO_SHOW = 10
